import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpRequest, HttpHandler } from '@angular/common/http';
import { Observable } from 'rxjs';
import { FirebaseService } from './services/firebase.service';

@Injectable()
export class MyInterceptor implements HttpInterceptor {

    constructor(
        private service: FirebaseService
    ) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const idToken = this.service.getAuthToken();
        if (idToken) {
            return next.handle(req.clone({ setHeaders: { idToken } }));
        }
        
        this.service.setAuthToken()
        return next.handle(req);
    }
}

export default MyInterceptor